import { set, lensProp, mergeRight, replace  } from "ramda";
import valueToContentAdapter from "form/adapter/valueToContentAdapter";

export function adaptFormToBack(value, structure, locale, title) {
  const form = {
    defaultLanguage: replace("-", "_", locale),
    structureId: structure.id,
    status: "PUBLISHED",
    categoriesId: [],
    tagsId: [],
    version: {
      language: replace("-", "_", locale),
      title: title,
      contentFields: value,
    }
  }
  return prepareContentForSubmit(form, structure);
}

const prepareContentForSubmit = (value, structure) => {
  const contentObject = valueToContentAdapter(value.version.contentFields, structure.structureFields);
  const valueWithContentWithoutNames = set(lensProp("version"), mergeRight(value.version, { contentFields: contentObject }), value);

  return valueWithContentWithoutNames;
};